export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_fragment_2.c4070678.jpg";